var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
const SvgSurveysDefault = _ref => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 226,
    height: 253,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.667 25.3v50.6h150.666V25.3h25.199c6.881 0 12.468 5.63 12.468 12.561V240.44a12.622 12.622 0 0 1-3.655 8.878 12.434 12.434 0 0 1-8.813 3.683H12.468a12.42 12.42 0 0 1-8.816-3.679A12.61 12.61 0 0 1 0 240.439V37.862C0 30.929 5.587 25.3 12.468 25.3h25.199Zm37.666 164.45h-25.11v25.3h25.11v-25.3Zm0-37.95h-25.11v25.3h25.11v-25.3Zm0-37.95h-25.11v25.3h25.11v-25.3ZM163.222 0v50.6H62.778V0h100.444Z",
    fill: "#E7E7E7"
  })));
};
export { SvgSurveysDefault as ReactComponent };
export default __webpack_public_path__ + "521a1ea24e6e22b3492a8d783b66d4a4.svg";